import { useHistory, useParams } from 'react-router-dom';
import MissionReportList from './MissionReportList/MissionReportList';
import MissionReportPage from './MissionReportPage/MissionReportPage';
import './MissionReporting.sass';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDeviceInfo from 'src/services/device/common/useDeviceInfo';
import { ScrollArea } from 'src/hci/common/ScrollArea/ScrollArea';
import classNames from 'classnames';
import { getDockMissions } from 'src/services/mission/MissionServiceSlice';
import { deviceTypes } from 'src/helper/constants';
import Loading from 'src/hci/common/Loading/Loading';

function MissionReporting() {
  const { deviceId, missionId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const deviceInfo = useDeviceInfo(deviceId);
  const devices = useSelector((state) => state.deviceService.devices?.filter(item => item.type === deviceTypes.DOCK));
  const missions = useSelector(state => state.missionService.dockMissions[deviceId]?.missions?.slice(0, 50));
  const selectedMission = missions?.find(mission => mission.id === missionId);

  const handleMissionSelection = (mission) => {
    history.push(`/dashboard/reporting-app/missions/${deviceId}/${mission.id}`);
  }

  const handleDeviceChange = (deviceId) => {
    history.push(`/dashboard/reporting-app/missions/${deviceId}`);
  }

  useEffect(() => {
    if(deviceId) {
      dispatch(getDockMissions(deviceId));
    }
  }, [deviceId]);

  useEffect(() => {
    if(!deviceId && devices?.length) {
      history.push(`/dashboard/reporting-app/missions/${devices?.[0]?.id}`);
      return;
    }
  }, [devices, deviceId]);

  return (
    <div className="mission-reporting">
      {deviceInfo ? (
        <div className="content">
          <div className={classNames("mission-list-container", {'side-view': !!missionId})}>
            <ScrollArea className="scroll-container">
              <MissionReportList 
                deviceInfo={deviceInfo} 
                devices={devices}
                missions={missions} 
                selectedMissionId={missionId} 
                onMissionSelection={handleMissionSelection} 
                onDeviceChane={handleDeviceChange} 
                sideView={!!missionId} 
              />
            </ScrollArea>
          </div>
          {missionId ? (
            <div className="report-page-container">
              <ScrollArea className="scroll-container">
                <MissionReportPage mission={selectedMission} />
              </ScrollArea>
            </div>
          ) : null}
        </div>
      ) : (
        <Loading message="Loading devices..." />
      )}
    </div>
  )
}

export default MissionReporting